module.exports = __webpack_public_path__ + "static/media/image1.f06fc00a.jpg";